import { lazyLoad } from 'utils/loadable';

export const TemplateEditorLoadable = lazyLoad(
  () => import('./index'),
  module => module.TemplateEditor,
);
